import { createFileRoute } from "@tanstack/react-router";

import { specificationSummaryByVersionQueryOptions } from "@/hooks/specifications";
import { requireSpecsAccess } from "@/lib/route-guards";
import {
  SPECIFICATIONS_BASE_PATH,
  legacySpecsVersionPath,
  parseRouteId,
  redirectOffTree,
} from "@/lib/route-paths";

// `/specs/:versionId/*` — the donor's `LegacySpecIdRedirect`
// (`routes/legacy-specification-id-redirect.tsx`): old bookmarks, whose id is
// a **version** id. It lands on that version's details route with the trailing
// path kept (`/specs/9/edit` → `…/versions/9/edit`), replacing the history
// entry. The read seeds the by-spec summary, so the page it lands on renders
// from a warm cache.
//
// **A dead id lands on the base list** (#678 Q9, a named break: the donor
// navigates to `/specifications/undefined/versions/<id>`). It renders nothing
// of its own, as the donor's renders `null` while it reads.

export const Route = createFileRoute("/_authed/_chrome/specs/$versionId/$")({
  beforeLoad: ({ context }) => {
    requireSpecsAccess(context.currentUser);
  },
  loader: async ({ context, params }) => {
    const versionId = parseRouteId(params.versionId);
    if (versionId === null) redirectOffTree(SPECIFICATIONS_BASE_PATH);
    const summary = await context.queryClient
      .ensureQueryData(specificationSummaryByVersionQueryOptions(context.queryClient, versionId))
      .catch(() => null);
    // An `href`, not a typed `to`: the splat is re-appended verbatim, so the
    // destination is whatever route it names — the details page or its edit.
    redirectOffTree(legacySpecsVersionPath(summary, versionId, params._splat));
  },
});
